import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";
import CopyApiTokenButton from "../../common/OverviewFooter/CopyApiTokenButton";
import styles from "./ConsoleComfyUILayout.module.scss";

interface Props {
	description?: string;
	hideCopyTokenBtn?: boolean;
	children: ReactNode;
}

const ConsoleComfyUILayout = ({ description, hideCopyTokenBtn = false, children }: Props) => {
	return (
		<Box className={styles.container}>
			<Box className={styles.header}>
				<Typography className={styles.description}>{description}</Typography>
				{!hideCopyTokenBtn && <CopyApiTokenButton />}
			</Box>

			<Box className={styles.content}>{children}</Box>
		</Box>
	);
};

export default ConsoleComfyUILayout;
